<template>
  <div v-if="cur_list.name !== undefined" class="device-group__custom">

    <div class="device-group__custom-info">
      <div class="header">
        <fg-input
          v-model="cur_list.name"
          class="name"
          type="text"
          placeholder="name group"
          :label="translate('custom.name')"
        />
        <button
          class="mdi mdi-content-save btn btn-success"
          @click.prevent="save_custom_device_list"
          :disabled="check_change"
        >
          <b>{{translate('save')}}</b>
        </button>

      </div>

      <div class="main_block">
        <div class="form-group w100">
          <label>{{ translate('custom.descr') }}</label>
          <textarea
            v-model="cur_list.description"
            rows="3"
            class="form-control border-input"
            :placeholder="translate('custom.descr')"
          />
        </div>
        <div class="inputs_list row">
          <router-link :to="{path: '/user/' + cur_list.created_by_user}"
                       class="link col-md-4"
          >
            <fg-input
                v-model="cur_list.created_by_user"
                class="w100"
                type="text"
                :label="translate('custom.created_by_user')"
                :placeholder="translate('custom.created_by_user')"
                :readonly="true"
                @click=""
            />
          </router-link>
          <fg-input
              v-model="created_at"
              class="col-md-4"
              type="text"
              :label="translate('custom.created')"
              :placeholder="translate('custom.created')"
              :readonly="true"
          />
          <fg-input
              v-model="updated_at"
              class="col-md-4"
              type="text"
              :label="translate('custom.updated')"
              :placeholder="translate('custom.updated')"
              :readonly="true"
          />
        </div>

        <div class="buttons">
          <span
              v-if="$store.getters.getPermissions.runDeviceRpc === true"
              class="manage_btns mdi mdi-console-line btn btn-primary btn-fill"
              @click.prevent="send_remote_command()"
          >
            {{ translate('device.rpc.send_remote_command') }}
          </span>

          <span
              v-if="device_list.length > 0"
              class="manage_btns mdi mdi-content-copy btn btn-primary btn-fill"
              @click.prevent="copy_fid()"
          >
            Copy FID
          </span>
        </div>

        <div class="block_tabs">
          <div class="tabs">
            <span class="tab_title" :class="{ active : block==='Device_list'}" @click="selected_block('Device_list')">
              {{ translate('custom.dev_list') }}
              {{ '('+ translate('custom.total') +': '+ count_device + ', '+translate('custom.online')+': ' + count_online_device + ')'}}
            </span>
            <span class="tab_title" :class="{ active : block==='User_list'}" @click="selected_block('User_list')">
              {{ translate('custom.user_list') }}
              {{ '('+ translate('custom.total') +': '+ count_users + ')'}}
            </span>
          </div>
          <div class="blocks">
            <DevicesList
                v-if="block==='Device_list'"
                :list_id="cur_list.id"
                :device_list="device_list"
                @delete_device="delete_device"
            />
            <UsersList
                v-if="block==='User_list'"
                :list="cur_list"
                :user_list="user_list"
                @delete_user="delete_user"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'
import DevicesList from "./DevicesList.vue";
import UsersList from "./UsersList.vue";
import MassRPC from "components/UIComponents/MassRPC/Index.vue";

export default {
  name: 'CustomDeviceListInfo',
  props: ['list'],
  components: {
    DevicesList,
    UsersList,
    SisIconStatus
  },
  data () {
    return {
      origin_list: {},
      cur_list: {},
      device_list: [],
      user_list: [],
      block: "Device_list"
    }
  },
  computed: {
    created_at(){
      return this.get_date(this.cur_list.created_at+1) // добавление 1 т.к. на тестовых данных 0, а 0 get_date не выводит
    },
    updated_at(){
      return this.get_date(this.cur_list.updated_at+1) // добавление 1 т.к. на тестовых данных 0, а 0 get_date не выводит
    },
    mobile_version(){
      return document.body.clientWidth < 768
    },
    check_change(){
      return (JSON.stringify(this.origin_list) === JSON.stringify(this.cur_list))
    },
    count_device(){
      return this.cur_list.devices.length
    },
    count_users(){
      return this.cur_list.users.length
    },
    count_online_device(){
      let cnt = 0
      for (let device of this.cur_list.devices) {
        if (device.status === 1){
          cnt++
        }
      }
      return cnt
    }
  },
  watch: {
    list () {
      if (Object.keys(this.list).length > 0){
        this.get_dev_info()
      }else{
        this.cur_list = {}
        this.origin_list = {}
        this.device_list = []
        this.user_list = []
      }
    }
  },
  methods: {
    copy_fid(){
      let string = ""
      let devices = [...this.device_list]
      devices.sort((a, b) => a.fid > b.fid ? 1 : -1).forEach(device => {
        string += `${device.fid}\n`
      })
      this.copy_to_clipboard(string)
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    send_remote_command(){
      let devices = this.cur_list.devices.map(device => {
        return {
          name: device.name2,
          fid: device.fid,
          device_id: device.id
        };
      });

      let t = this.$createElement(MassRPC, {
        props: {
          devices
        },
        on: {
          close: () => {
            this.$modal.hide('mass_rpc')
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: "auto", width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'mass_rpc'})

    },
    selected_block(block){
      this.block = block
    },
    get_dev_info(){
      if (+this.list.id > 0){
        this.$http.v1.getInfoCustomDeviceList(this.list.id, (response) => {
          this.cur_list = {...response.data}
          this.origin_list = {...response.data}
          this.device_list = response.data.devices
          this.user_list = response.data.users
        })
      }
    },
    delete_device(device){
      let info = {
        device_list_id: this.list.id,
        device_id: device.id
      }
      this.$http.v1.removeDeviceCustomDeviceList(info , (response) => {
        if (response.data) {
          this.$store.dispatch('customListUpdate')
          this.$emit('update')
          this.get_dev_info()
          this.global_notify('info', this.translate('custom.remove_device_success'))
        }else{
          this.global_notify('danger', this.translate('custom.remove_device_error'))
        }
      })
    },
    delete_user(user){
      let info = {
        device_list_id: this.list.id,
        user_id : user.user_id
      }
      this.$http.v1.removeUserCustomDeviceList(info , (response) => {
        if (response.data) {
          this.$store.dispatch('customListUpdate')
          this.$emit('update')
          this.global_notify('info', this.translate('custom.remove_user_success'))
        }else{
          this.global_notify('danger', this.translate('custom.remove_user_error'))
        }
      })
    },
    device_name (device) {
      let name = "ID: " + device.fid +'<br>'+ device.name2
      if (this.$store.getters.getPermissions.permissionGod) {
        name += '<br>' + device.name
      }
      return name
    },
    save_custom_device_list () {
      let sended_list = {...this.cur_list}
      if (sended_list.devices){
        let devices = []
        for (let device of this.cur_list.devices) {
          devices.push(device?.id)
        }
        sended_list.devices = devices
      }
      this.$http.v1.editCustomDeviceList(this.cur_list.id, {...sended_list},() => {
        this.global_notify('info', this.translate('custom.add_list_success'))
        this.$emit('update')
        this.$store.dispatch('customListUpdate')
      })
    },
  }
}
</script>

<style lang='scss' scoped>
  .device-group{
    &__custom{
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding: 10px;
      &-info{
        margin-bottom: 10px;
        height: 100%;
        .header{
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          flex-wrap: wrap;
          margin-bottom: 10px;
          height: 8%;
          @media (max-width: 768px) {
            height: auto;
          }

          .name{
            width: calc(70% - 10px);
            margin-bottom: 0;
          }
          .btn{
            padding: 7px;
            height: 40px;
            width: 30%;
          }
        }
        .main_block{
          opacity: 1;
          transition: 0.3s;
          height: 91.5%;
          @media (max-width: 768px) {
            height: auto;
          }
          .buttons{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            margin-bottom: 10px;
          }
          &.-hide{
            height: 0;
            opacity: 0;
          }
          .form-group{
            margin-bottom: 10px;
          }
          .inputs_list{
            .link{
              cursor: pointer;
            }
          }
          .btn{
            width: 100%;
          }
          .block_tabs{
            width: 100%;
            height: 70%;
            .tabs{
              height: 30px;
              display: flex;
              .tab{
                width: 50%;
              }
            }
            .blocks{
              height: calc(100% - 30px);
            }
          }
          .w33{
            width: 33%;
          }
          .w50{
            width: 50%;
          }
          .w100{
            width: 100%;
          }
        }
      }
    }
  }

  @media (max-width:1560px) {
    .device-group{
      &__custom{
        &-info{
          .main_block{
            height: 79.5%;
          }
        }
      }
    }
  }

  @media (max-width:768px) {
    .device-group{
      &__custom{
        overflow: auto;
        padding: 10px 10px 10px 0;
        &-info{
          .header{
            .btn{
              b{
                display: none;
              }
            }
          }
          .main_block{
            .response_table{
              margin: 0;
            }
          }
        }
      }
    }
  }
</style>
